import * as THREE from 'three';

export class FikoGoochShader extends THREE.ShaderMaterial {
  constructor() {
    super({
      uniforms: {
        uWarmColor: { value: new THREE.Color(0.8, 0.6, 0.2) },   // A research doc value
        uCoolColor: { value: new THREE.Color(0.2, 0.2, 0.6) },   // A research doc value
        uSurfaceColor: { value: new THREE.Color(0.7, 0.7, 0.7) }, // Default surface color
        uLightDir: { value: new THREE.Vector3(0.0, 0.0, 1.0) }, // Default light direction
        uAlpha: { value: 0.25 }, // Cool mix factor
        uBeta: { value: 0.5 },  // Warm mix factor
      },
      vertexShader: `
        varying vec3 vNormal;
        varying vec3 vViewPosition;
        void main() {
          vNormal = normalize(normalMatrix * normal);
          vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
          vViewPosition = mvPosition.xyz;
          gl_Position = projectionMatrix * mvPosition;
        }
      `,
      fragmentShader: `
        precision highp float;
        uniform vec3 uWarmColor;
        uniform vec3 uCoolColor;
        uniform vec3 uSurfaceColor;
        uniform vec3 uLightDir;
        uniform float uAlpha;
        uniform float uBeta;
        varying vec3 vNormal;
        varying vec3 vViewPosition;

        void main() {
          vec3 n = normalize(vNormal);
          vec3 l = normalize(uLightDir);
          float NdotL = dot(n, l);
          float t = (NdotL + 1.0) * 0.5;  // [-1,1] -> [0,1]

          vec3 cool = uCoolColor + uAlpha * uSurfaceColor;
          vec3 warm = uWarmColor + uBeta * uSurfaceColor;
          vec3 color = mix(cool, warm, t);

          vec3 viewDir = normalize(-vViewPosition);
          vec3 halfVec = normalize(l + viewDir);
          float spec = pow(max(dot(n, halfVec), 0.0), 64.0);
          color += vec3(1.0) * spec * 0.3;

          gl_FragColor = vec4(color, 1.0);
        }
      `,
      lights: false,
      side: THREE.DoubleSide,
      dithering: true,
    });
  }
}
